/// <reference types="googlemaps" />
import { Component, OnInit, ViewChild, ElementRef, NgZone, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-google-map-autofill',
  templateUrl: './google-map-autofill.component.html',
  styleUrls: ['./google-map-autofill.component.css']
})
export class GoogleMapAutofillComponent implements OnInit {
  @ViewChild('search') searchInput:ElementRef;
  searchControl:FormControl;
  @Output() placeSelected = new EventEmitter<any>();
  venueSetting: any;

  constructor(
    private googleMapApiLoader: MapsAPILoader,
    private ngZone: NgZone,
    private router: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.searchControl = new FormControl();
    this.venueSetting = this.router.snapshot.data['venueSettings'];
    let countryCode = '';
     switch (this.venueSetting.country) {
      case 'New Zealand':
        countryCode = 'NZ';
        break;
      case 'United Kingdom':
        countryCode = 'UK';
        break;
      case 'United States':
        countryCode = 'US';
        break;
      default:
        countryCode = 'AU';
        break;
    }
   
    this.loadMapAPI(countryCode);
  }

  loadMapAPI(country_code){
    this.googleMapApiLoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchInput.nativeElement, {
        types: ["address"],
        componentRestrictions: {country: country_code}
      });
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.placeSelected.emit(place);
        });
      });
    });
  }

  

}
